import { render, staticRenderFns } from "./ProductWindow1.vue?vue&type=template&id=f8377f6c&scoped=true"
import script from "./ProductWindow1.vue?vue&type=script&lang=js"
export * from "./ProductWindow1.vue?vue&type=script&lang=js"
import style0 from "./ProductWindow1.vue?vue&type=style&index=0&id=f8377f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8377f6c",
  null
  
)

export default component.exports